// frontend/src/api/stamps.api.ts
import axios from './axios';

export interface SavedStamp {
  id: number;
  name: string;
  image_data: string;
  created_at: string;
  created_by: number | null;
}

export const stampsApi = {
  // Получить список сохранённых печатей
  getAll: () => axios.get<{ success: boolean; data: SavedStamp[] }>('/stamps'),

  // Сохранить новую печать
  create: (data: { name: string; image_data: string }) =>
    axios.post<{ success: boolean; data: SavedStamp; message: string }>('/stamps', data),

  // Удалить печать
  delete: (id: number) =>
    axios.delete<{ success: boolean; message: string }>(`/stamps/${id}`),
};
